<template>
    <div>
        <div
            class="caption soli-grey"
            v-if="attendance.rescheduled_to"
        >
            {{
                `Rescheduled: ${globalMomentDateAtTimeDots(
                    attendance.rescheduled_to
                )}`
            }}
        </div>
        <div
            class="caption soli-grey"
            v-if="
                attendance.reschedule_minutes >
                0
            "
        >
            {{
                `${
                    attendance.reschedule_minutes
                } min remaining`
            }}
        </div>
        <div
            class="caption soli-grey"
            v-if="attendance.reschedule_pass"
        >
            1 visit remaining
        </div>
    </div>
</template>

<script>
import globalMoment from "../../../Mixins/GlobalMoment.js";

export default {
    mixins: [globalMoment],
    props: {
        attendance: {
            type: Object,
            default: ()=>{}
        }
    }
}
</script>